/* eslint-disable camelcase */
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class CustomQuoteService {
    /**
     * Selects a quote
     * @param {String} quoteID the quote ID
     * @param {String} branchName the name of the selected quote
     * @param {String} sessionUUID the session UUID associated to the quoteID
     * @param {Object} [additionalHeaders] additional headers to pass to the backend (e.g. auth)
     * @returns {Promise} a promise from the backend call with no result (if successful)
     */
    static setSelectedVersionOnSubmission(
        quoteID,
        branchName,
        sessionUUID,
        additionalHeaders = {}
    ) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayquote/customquote'),
            'setSelectedVersionOnSubmission',
            [quoteID, branchName, sessionUUID],
            additionalHeaders
        );
    }

    /**
     * Updates a custom quote
     * @param {Object} customQuoteDTO CustomQuoteDataDTO
     * @param {Object} [additionalHeaders] additional headers to pass to the backend (e.g. auth)
     * @returns {Promise} a promise from the backend call with no result (if successful)
     */
    static updateCustomQuote(customQuoteDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayquote/customquote'),
            'updateCustomQuote',
            [customQuoteDTO],
            additionalHeaders
        );
    }

    /**
     * Updates a custom quote coverage
     * @param {Object} customQuoteDTO CustomQuoteDataDTO
     * @param {Object} [additionalHeaders] additional headers to pass to the backend (e.g. auth)
     * @returns {Promise} a promise from the backend call with no result (if successful)
     */
    static updateCustomQuoteCoverages(customQuoteDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayquote/customquote'),
            'updateCustomQuoteCoverages',
            [customQuoteDTO],
            additionalHeaders
        );
    }

    /**
     * Force Updates a custom quote coverage
     * @param {Object} customQuoteDTO CustomQuoteDataDTO
     * @param {Object} [additionalHeaders] additional headers to pass to the backend (e.g. auth)
     * @returns {Promise} a promise from the backend call with no result (if successful)
     */
    static forceUpdateCustomQuoteCoverages(customQuoteDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayquote/customquote'),
            'forceUpdateCustomQuoteCoverages',
            [customQuoteDTO],
            additionalHeaders
        );
    }

    static requestQuotesForSpecifPaymentPlans(sessionUUID, quoteID, quoteBaseVersion,
        selectedPayments, additionalHeaders = {}) {
        const customQuoteDTOs = selectedPayments.map((selectedPayment) => {
            return {
                sessionUUID: sessionUUID,
                quoteID: quoteID,
                quoteBaseVersion_ML: quoteBaseVersion,
                ratingPaymentMethod_ML: selectedPayment.ratingPaymentMethod_ML,
                ratingPaymentSchedule_ML: selectedPayment.ratingPaymentSchedule_ML,
                customizableQuote_ML: false,
                markAsSelectedVersion_ML: selectedPayment.markAsSelectedVersion_ML
            };
        });
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayquote/customquote'),
            'requestQuotesForSpecifPaymentPlans',
            [customQuoteDTOs],
            additionalHeaders
        );
    }
    
    static createQuoteForSpecificPaymentPlan(sessionID, quoteID, quoteBaseVersion, selectedPayment, additionalHeaders = {}) {
        const customQuoteDTO = {
            sessionUUID: sessionID,
            quoteID,
            quoteBaseVersion_ML: quoteBaseVersion,
            ratingPaymentMethod_ML: selectedPayment.ratingPaymentMethod_ML,
            ratingPaymentSchedule_ML: selectedPayment.ratingPaymentSchedule_ML,
            customizableQuote_ML: false
        };
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayquote/customquote'),
            'createQuoteForSpecificPaymentPlan',
            [customQuoteDTO],
            additionalHeaders
        );
    }

    static createQuoteForSpecificPaymentPlanAndGetDownPaymentDetails_ML(sessionID, quoteID, quoteBaseVersion, selectedPayment, additionalHeaders = {}) {
        const customQuoteDTO = {
            sessionUUID: sessionID,
            quoteID,
            quoteBaseVersion_ML: quoteBaseVersion,
            ratingPaymentMethod_ML: selectedPayment.ratingPaymentMethod_ML,
            ratingPaymentSchedule_ML: selectedPayment.ratingPaymentSchedule_ML,
            customizableQuote_ML: false
        };
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayquote/customquote'),
            'createQuoteForSpecificPaymentPlanAndGetDownPaymentDetails',
            [customQuoteDTO],
            additionalHeaders
        );
    }

    static updatePolicyAccountHolderContact(request, emailAddress, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayquote/customquote'),
            'updatePolicyAccountHolderContact',
            [request, emailAddress],
            additionalHeaders
        );
    }

    static updatePriorCarrierPremium(request, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayquote/customquote'),
            'updatePriorCarrierPremium',
            [request],
            additionalHeaders
        );
    }
    
    static requoteOffering(request, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayquote/customquote'),
            'requoteOffering',
            [request],
            additionalHeaders
        );
    }
}
